import React, { useState } from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import styles from './DuplicateComponents.module.css';

// Publish Feed button + confirm modal (DEV-11955). Visible on the slide deck
// detail header for external admins on accounts with Allow Feed Publishing
// enabled; styled to match the adjacent Duplicate button.

export const PublishFeedButton = ({
	onOpenModal,
	hasChanges,
	handleSave,
	isSaving = false,
	isPublished = false,
}) => {
	const [
		isForceSaving,
		setIsForceSaving,
	] = useState(false);

	const handleClick = async () => {
		if (hasChanges) {
			setIsForceSaving(true);
			try {
				await handleSave();
			} catch (e) {
				window.alert('Error saving changes. Please try again before publishing.');
				setIsForceSaving(false);
				return;
			}
			setIsForceSaving(false);
		}
		onOpenModal();
	};

	const isDisabled = isSaving || isForceSaving;
	const label = isPublished ? 'Unpublish Feed' : 'Publish Feed';

	return (
		<button
			className={`button ${isDisabled ? 'button-disabled' : ''} ${styles.duplicateBtn}`}
			onClick={handleClick}
			disabled={isDisabled}
			title={isDisabled ? 'Saving...' : label}
			data-test-id="publishFeedButton"
		>
			<CustomIcon icon="broadcast-tower" />
			{label}
		</button>
	);
};

export const PublishFeedModal = ({
	app,
	onConfirm,
	deckName = 'this Slide Deck',
	isPublished = false,
}) => {
	const [
		isWorking,
		setIsWorking,
	] = useState(false);
	const [
		errorMsg,
		setErrorMsg,
	] = useState('');

	const actionLabel = isPublished ? 'Unpublish' : 'Publish';

	const handleConfirm = async () => {
		if (isWorking) {
			return;
		}
		setIsWorking(true);
		setErrorMsg('');
		try {
			await onConfirm();
			app.closeModal();
		} catch (e) {
			setErrorMsg(e.toString());
			setIsWorking(false);
		}
	};

	return (
		<div className={styles.duplicateModalBody}>
			<div className={styles.duplicateModalFormGroup}>
				<p>
					{isPublished
						? `Unpublish the feed for "${deckName}"? This Published Feed will be disabled in every Visual Content Loop in which it is assigned.`
						: `Publish "${deckName}" as a feed? It will appear under Published Feeds in the Visual Content Loop content list on every account where you are a user.`}
				</p>
				{errorMsg && (
					<p className={styles.duplicateModalError}>
						{errorMsg}
					</p>
				)}
			</div>
			<div className={styles.duplicateModalFooter}>
				<button
					className={`button ${styles.duplicateModalCancelBtn}`}
					disabled={isWorking}
					onClick={() => {
						app.closeModal();
					}}
				>
					<div>Cancel</div>
				</button>
				<button
					className={`button ${styles.duplicateModalActionBtn}`}
					disabled={isWorking}
					onClick={handleConfirm}
					data-test-id="publishFeedConfirmButton"
				>
					<CustomIcon icon="broadcast-tower" />
					<div>{isWorking ? `${actionLabel}ing...` : actionLabel}</div>
				</button>
			</div>
		</div>
	);
};
